// extracted by mini-css-extract-plugin
module.exports = {"Root":"styles_Root__EwXzY","Hand":"styles_Hand__t1iT2","wave":"styles_wave__6E4oX"};